<script>
import { mapGetters } from 'vuex'
import PaymentMethod from '../../components/PaymentMethod.vue'
import CashWallet from '../../components/CashWallet.vue'

export default {
    name: 'AccountPayment',
    components: { PaymentMethod, CashWallet },
    computed: {
        ...mapGetters(['userResource']),
        showCashWallet() {
            return !!(this.userResource && this.userResource.get('cash_wallet_enabled'))
        }
    }
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Pago</h4>
            <p class="text-muted mb-0">Gestiona el método de pago guardado.</p>
        </div>
        <b-card>
            <b-row>
                <b-col md="6">
                    <h4>Tarjeta de crédito</h4>
                    <payment-method cols-lg="12" :user-resource="userResource" />
                    <hr class="d-block d-md-none" />
                </b-col>
                <b-col>
                    <h4>Monedero para torneos con premio en efectivo</h4>
                    <cash-wallet />
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
